// Mock data for DrMobil Strommen website

export const businessInfo = {
  name: "DrMobil Strommen",
  phone: "94076761",
  email: "drmobil.infonorge@gmail.com",
  address: "Stoperiveien 5, 2010 Strommen, Norge",
  location: "Strommen storsenter",
  openingHours: {
    weekdays: "10:00 - 21:00",
    saturday: "10:00 - 19:00",
    sunday: "Stengt"
  }
};

export const heroSlides = [
  {
    id: 1,
    title: "Knust skjerm?",
    subtitle: "Ingen problem!",
    description: "Vi fikser skjerm på alle enheter mens du venter!",
    highlight: "30 minutter",
    highlightText: "De fleste reparasjoner tar ca. 30 minutter.",
    image: "https://images.unsplash.com/photo-1576613109753-27804de2cba8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxwaG9uZSUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NjV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Dårlig batteri?",
    subtitle: "Ingen problem!",
    description: "Vi bytter batteri på alle enheter mens du venter!",
    highlight: "30 minutter",
    highlightText: "De fleste reparasjoner tar ca. 30 minutter.",
    image: "https://images.unsplash.com/photo-1550041473-d296a3a8a18a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwaG9uZSUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NjV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "PC eller Laptop trøbbel?",
    subtitle: "Vi hjelper deg!",
    description: "Rask og profesjonell reparasjon av alle typer datamaskiner!",
    highlight: "Ekspertservice",
    highlightText: "Erfarne teknikere som fikser alt.",
    image: "https://images.unsplash.com/photo-1721332154191-ba5f1534266e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxlbGVjdHJvbmljcyUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NzB8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const brands = [
  { name: "Apple", logo: "🍎" },
  { name: "Samsung", logo: "📱" },
  { name: "Huawei", logo: "📲" },
  { name: "Sony", logo: "🎮" },
  { name: "Xiaomi", logo: "📱" },
  { name: "Nokia", logo: "📞" },
  { name: "Motorola", logo: "📱" },
  { name: "Google", logo: "🔍" },
  { name: "LG", logo: "📺" },
  { name: "OnePlus", logo: "➕" }
];

export const whyChooseUs = [
  {
    icon: "Award",
    title: "Premium service",
    description: "Reparasjoner med deler av beste kvalitet"
  },
  {
    icon: "Zap",
    title: "Rask reparasjon",
    description: "Tjenesten er fullført mens du venter"
  },
  {
    icon: "Shield",
    title: "Beskyttelse",
    description: "Vi beskytter din enhet etter reparasjon"
  },
  {
    icon: "BadgeCheck",
    title: "2 års garanti",
    description: "Vi gir garanti til alle våre deler"
  }
];

export const services = [
  {
    id: 1,
    category: "Mobiltelefon",
    title: "Mobilreparasjon",
    description: "Vi reparerer alle typer mobiltelefoner - iPhone, Samsung, Huawei, og mer.",
    image: "https://images.unsplash.com/photo-1576613109753-27804de2cba8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxwaG9uZSUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NjV8MA&ixlib=rb-4.1.0&q=85",
    repairs: [
      "Skjermbytte",
      "Batteribytte",
      "Ladeport reparasjon",
      "Kamera bytte",
      "Høyttaler reparasjon",
      "Vannskade behandling"
    ]
  },
  {
    id: 2,
    category: "PC & Laptop",
    title: "PC og Laptop reparasjon",
    description: "Profesjonell reparasjon av alle typer PC-er og laptops.",
    image: "https://images.unsplash.com/photo-1721332154191-ba5f1534266e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxlbGVjdHJvbmljcyUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NzB8MA&ixlib=rb-4.1.0&q=85",
    repairs: [
      "Skjermbytte laptop",
      "Tastatur bytte",
      "SSD/HDD oppgradering",
      "RAM oppgradering",
      "Virusfjerning",
      "Operativsystem installasjon"
    ]
  },
  {
    id: 3,
    category: "Nettbrett",
    title: "Nettbrett reparasjon",
    description: "Reparasjon av iPad, Samsung tablets og andre nettbrett.",
    image: "https://images.unsplash.com/photo-1611396000732-f8c9a933424f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwaG9uZSUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NjV8MA&ixlib=rb-4.1.0&q=85",
    repairs: [
      "Skjermbytte",
      "Batteribytte",
      "Ladeport reparasjon",
      "Programvare oppdatering",
      "Digitizer bytte"
    ]
  },
  {
    id: 4,
    category: "Tilbehør",
    title: "Tilbehør salg",
    description: "Vi selger kvalitetstilbehør for alle enheter.",
    image: "https://images.unsplash.com/photo-1617299516258-eb06985065ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxlbGVjdHJvbmljcyUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxODE3NzB8MA&ixlib=rb-4.1.0&q=85",
    items: [
      "Skjermbeskyttere",
      "Deksler og covers",
      "Ladere og kabler",
      "Hodetelefoner",
      "Powerbanks",
      "Adaptere"
    ]
  }
];

export const prices = {
  mobile: [
    { model: "iPhone 15 Pro", repair: "Skjermbytte", price: "Fra 3500 kr" },
    { model: "iPhone 15", repair: "Skjermbytte", price: "Fra 3200 kr" },
    { model: "iPhone 14 Pro", repair: "Skjermbytte", price: "Fra 3000 kr" },
    { model: "iPhone 14", repair: "Skjermbytte", price: "Fra 2800 kr" },
    { model: "iPhone 13", repair: "Skjermbytte", price: "Fra 2500 kr" },
    { model: "iPhone 12", repair: "Skjermbytte", price: "Fra 2200 kr" },
    { model: "Samsung S24", repair: "Skjermbytte", price: "Fra 2800 kr" },
    { model: "Samsung S23", repair: "Skjermbytte", price: "Fra 2500 kr" },
    { model: "Samsung S22", repair: "Skjermbytte", price: "Fra 2200 kr" },
  ],
  battery: [
    { model: "iPhone 15 / 15 Pro", repair: "Batteribytte", price: "Fra 800 kr" },
    { model: "iPhone 14 / 14 Pro", repair: "Batteribytte", price: "Fra 750 kr" },
    { model: "iPhone 13 / 13 Pro", repair: "Batteribytte", price: "Fra 700 kr" },
    { model: "iPhone 12 / 12 Pro", repair: "Batteribytte", price: "Fra 650 kr" },
    { model: "Samsung S24 / S23", repair: "Batteribytte", price: "Fra 700 kr" },
    { model: "Samsung S22 / S21", repair: "Batteribytte", price: "Fra 650 kr" },
  ],
  other: [
    { model: "Alle modeller", repair: "Ladeport", price: "Fra 500 kr" },
    { model: "Alle modeller", repair: "Kamera", price: "Fra 600 kr" },
    { model: "Alle modeller", repair: "Høyttaler", price: "Fra 500 kr" },
    { model: "PC/Laptop", repair: "Diagnose", price: "Gratis" },
    { model: "PC/Laptop", repair: "Virusfjerning", price: "Fra 600 kr" },
    { model: "PC/Laptop", repair: "SSD oppgradering", price: "Fra 1200 kr" },
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Lars Hansen",
    rating: 5,
    comment: "Veldig fornøyd med servicen! Fikk byttet skjerm på iPhone mens jeg handlet. Super rask og profesjonell betjening.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Maria Olsen",
    rating: 5,
    comment: "Anbefales på det sterkeste! Fikk reparert laptop samme dag. Kjempe service og gode priser.",
    date: "2024-01-10"
  },
  {
    id: 3,
    name: "Erik Johansen",
    rating: 5,
    comment: "Topp kvalitet på reparasjon. Mobilen min virker perfekt etter skjermbytte. Takk!",
    date: "2024-01-05"
  }
];
